import { useState } from "react";
import { usePode } from "@/lib/permissoes";
import { Button } from "@/components/ui/button";
import { Handshake } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { ModalFormalizar } from "./formalizar-comprador";

/**
 * Formalizar direto da LISTA de romaneios, sem abrir a venda.
 *
 * ⚠️ Existe por causa do backfill do C2: o produtor vai formalizar dezenas de vendas
 * antigas em silêncio, antes de convidar o corretor. Obrigá-lo a abrir cada venda
 * para isso transformaria meia hora de trabalho em uma tarde.
 *
 * Reusa o MESMO modal do card da venda — inclusive a prévia do texto. Um segundo
 * fluxo de formalização seria a segunda chance de as duas telas discordarem sobre o
 * que a mensagem diz.
 */
export function BotaoFormalizar({
  vendaId, status, compradorNome, telefoneCadastro, jaFormalizada, compacto,
}: {
  vendaId: string;
  status: string;
  compradorNome: string;
  telefoneCadastro?: string | null;
  jaFormalizada: boolean;
  compacto?: boolean;
}) {
  const { toast } = useToast();
  const [aberto, setAberto] = useState(false);
  // Formalizar é `mercado.operar` (ADMIN/GESTOR; nunca em modo suporte).
  const podeOperar = usePode("mercado.operar");

  // EMITIDA e PAGA — as mesmas do card da venda.
  if (status !== "EMITIDA" && status !== "PAGA") return null;
  if (jaFormalizada) return null;
  if (!podeOperar) return null;

  return (
    <>
      <Button
        variant="outline"
        size={compacto ? "icon" : "sm"}
        className={compacto ? "h-7 w-7" : undefined}
        aria-label={`Formalizar com ${compradorNome}`}
        onClick={(e) => { e.stopPropagation(); setAberto(true); }}
        data-testid={`button-formalizar-lista-${vendaId}`}
      >
        <Handshake className={compacto ? "h-3.5 w-3.5" : "h-4 w-4 mr-1.5"} />
        {!compacto && "Formalizar"}
      </Button>

      {aberto && (
        <div onClick={(e) => e.stopPropagation()}>
          <ModalFormalizar
            vendaId={vendaId}
            compradorNome={compradorNome}
            telefoneCadastro={telefoneCadastro}
            vendaPaga={status === "PAGA"}
            onFechar={() => setAberto(false)}
            onPronto={() => {
              setAberto(false);
              toast({ title: "Romaneio formalizado!", description: `Abra a venda para enviar a ${compradorNome}.` });
            }}
          />
        </div>
      )}
    </>
  );
}
